module.exports = __webpack_public_path__ + "static/media/RobinCare_logo_Favicon (1).fe55dc3b.png";